import { Icons } from '@/app/components/ui/Icons'
import { getFacilityIcon } from '@/app/utils/facilityIcons'
import { ReactElement } from 'react'

export enum AmenityName {
	WIFI_INTERNET = 'wifiInternet',
	KITCHEN = 'kitchen',
	PARKING = 'parking',
	AIR_CONDITIONED = 'airConditioned',
	PET_FRIENDLY = 'petFriendly',
	SELF_CHECK_IN = 'selfCheckIn',
	NO_SMOKING = 'noSmoking',
	ELEVATOR = 'elevator',
	WHEELCHAIR_ACCESSIBLE = 'wheelchairAccessible',
	CRIBS_AVAILABLE = 'cribsAvailable',
	LAUNDRY_FACILITIES = 'laundryFacilities',
}

/**
 * Maps amenity names to their corresponding icons
 * Returns the icon component with appropriate size for mobile filters
 * First checks for custom SVG icons, then falls back to existing Icons
 */
export const getAmenityIcon = (amenityName: AmenityName): ReactElement | null => {
	const iconProps = { width: '24px', height: '24px' }

	// First try to get custom facility icon
	const customIcon = getFacilityIcon(amenityName)
	if (customIcon) {
		return customIcon
	}

	// Fall back to existing Icons system
	switch (amenityName) {
		case AmenityName.WIFI_INTERNET:
			return <Icons.wifi {...iconProps} />
		case AmenityName.KITCHEN:
			return <Icons.kitchen {...iconProps} />
		case AmenityName.PARKING:
			return <Icons.parking {...iconProps} />
		case AmenityName.AIR_CONDITIONED:
			return <Icons.airConditioner {...iconProps} />
		case AmenityName.PET_FRIENDLY:
			return <Icons.pets {...iconProps} />
		case AmenityName.SELF_CHECK_IN:
			return <Icons.iconCheckin {...iconProps} />
		case AmenityName.NO_SMOKING:
			// Using a generic icon or placeholder - you may want to add a specific no-smoking icon
			return <Icons.iconClose {...iconProps} />
		case AmenityName.ELEVATOR:
			// Using a generic icon or placeholder - you may want to add a specific elevator icon
			return <Icons.iconAngle {...iconProps} />
		case AmenityName.WHEELCHAIR_ACCESSIBLE:
			// Using a generic icon or placeholder - you may want to add a specific wheelchair icon
			return <Icons.iconAngle {...iconProps} />
		case AmenityName.CRIBS_AVAILABLE:
			// Using a generic icon or placeholder - you may want to add a specific crib icon
			return <Icons.family {...iconProps} />
		case AmenityName.LAUNDRY_FACILITIES:
			// Using a generic icon or placeholder - you may want to add a specific laundry icon
			return <Icons.houseKeeping {...iconProps} />
		default:
			return null
	}
}

